import BaseViewController from "./base-view-controller";
import buildProviders from "./helpers/provider-list";
import { FILTER_OPTIONS_FIELD } from "../utils/constants";

class ProviderListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    // this hidden field is missing in /screens/request_consult/nut response 'hidden_fields' object for some reason.
    // Commented out due to breaking MH flow.  See https://teladoc.atlassian.net/browse/HEAL-8065
    // values.health_category = "Nutrition";

    return { ...values, ...this.formState };
  }

  preprocessScreenData() {
    if (!this.appData.providerDetailFieldsData?.length) {
      this.appData.setDetailProviderFieldsData(
        this.appData.data.screens.find(
          screen => screen.identifier === "ConsultationBhProviderProfile"
        )?.fields
      );
    }

    const providerList = (
      buildProviders(
        this.screen.data?.list_data,
        this.components,
        (name, text, action) => this.handleButtonClick(name, text, action),
        this.screen.action,
        this.screen.name,
        this.appData.settings
      ) || []
    ).map(provider => {
      if (provider.type === "listItemWrapper") {
        return { ...provider, action: this.screen.action };
      } else {
        return { type: "raw", el: provider };
      }
    });
    this.screen = {
      ...this.screen,
      fields: [...this.screen.fields, ...providerList]
    };
  }

  handleButtonClick(name, text, action, history, initialScreen, eventStates) {
    let replaceHistory = history || 0;

    if (name === "pop_flow") {
      replaceHistory = 1;
      this.formState = {
        date_search: "",
        name_search: "",
        name: "",
        language: "",
        gender: "",
        available_now: "",
        "Available Now": "",
        [FILTER_OPTIONS_FIELD.name]: [],
        "specialties.0": "",
        "specialties.1": "",
        "specialties.2": "",
        can_prescribe: ""
      };

      if (
        this.screen?.params?.includes("TDScreenOptionAddFilterStateOnPopFlow")
      )
        this.formState.filter_state = "";
    }

    if (name === "selectedData") {
      this.formState = {
        "requested_dates.0": "",
        "requested_dates.1": "",
        "requested_dates.2": "",
        ...text
      };
    }
    if (name === "provider_profile") {
      this.appData.setDetailProviderData(
        this.screen.data.list_data.find(
          provider => provider.detail_data.name === text
        ).detail_data
      );
    }

    if (name === "providerProfileLink" && action?.data?.templated_list) {
      const { data } = action.data.templated_list;
      this.appData.setDetailProviderData(data);
    }

    super.handleButtonClick(
      name,
      text,
      action,
      replaceHistory,
      initialScreen,
      eventStates
    );
  }
}

export default ProviderListViewController;
